module.exports = __webpack_public_path__ + "static/media/like.fc7f43ea.svg";